import { useState } from 'react';
import { mediaUrl } from '@/lib/supabase';
import { cn } from '@/lib/utils';

/** Фото из Storage с плавным появлением и заглушкой, если файл недоступен. */
export function Photo({
  path,
  alt,
  className,
  eager = false,
}: {
  path: string | null | undefined;
  alt: string;
  className?: string;
  eager?: boolean;
}) {
  const [state, setState] = useState<'loading' | 'ok' | 'error'>('loading');
  const src = mediaUrl(path);
  if (!src || state === 'error') {
    return <span role="img" aria-label={alt} className={cn('block bg-surface', className)} />;
  }
  return (
    <img
      src={src}
      alt={alt}
      loading={eager ? 'eager' : 'lazy'}
      decoding="async"
      fetchPriority={eager ? 'high' : 'auto'}
      onLoad={() => setState('ok')}
      onError={() => setState('error')}
      className={cn(
        'block object-cover bg-surface transition-opacity duration-300 motion-reduce:transition-none',
        state === 'ok' ? 'opacity-100' : 'opacity-0',
        className,
      )}
    />
  );
}
